import { STUDENT_DISCOUNT_PATHS } from '@utils/studentDiscount/urls';

export function setStudentDiscountReturnUrl(
  links: NodeListOf<HTMLAnchorElement> | HTMLAnchorElement[]
) {
  const match = Array.from(links).find(link => {
    const url = new URL(link.getAttribute('href') || '', window.location.origin);
    const pathname = url.pathname;

    return Object.values(STUDENT_DISCOUNT_PATHS).some(path => pathname.includes(path));
  });

  if (match) {
    sessionStorage.setItem('studentDiscountReturnUrl', window.location.href);
  }
}
